function galleryList() {
    /// <summary>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 02.12.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.5.2 - 19.01.2018                                               *<br />
    /// **********************************************************************<br />
    /// *- editable for ws-calls better integrated                          *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.5.1 - 09.03.2016                                               *<br />
    /// **********************************************************************<br />
    /// *- bug with deviceType fixed (is now 1 and not 2)                    *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.5.0 - 14.01.2016                                               *<br />
    /// **********************************************************************<br />
    /// *- changed to support the FileViewer as Main Image viewing Instrument*<br />
    /// *- added Events:                                                     *<br />
    /// *    + GAL_OPEN_FILEVIEWER                                           *<br />
    /// *    + GAL_ADD_TO_LIST                                               *<br />
    /// *    + GAL_EDIT_FILE                                                 *<br />
    /// *    + GAL_SEND_EMAIL                                                *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 27.11.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - migrated from Gallery to template.js only for JqGRid             *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.source = "galleryList";
}

galleryList.prototype = new window.vcTemplate();

galleryList.prototype.init = function () {
    /// <summary>
    /// This function inits the galleryList and loads the Files
    /// </summary>
    var me = this;
    var image;
    var mobileClass = "";

    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        $(".galleryList > div").last().css({ "z-index": 100000 });
        if (me.rows.length < 1) {
            me.showEmptyMessage();
        }
        if (me.mobile === true) {
            mobileClass = "mb";
        }
        //for now add a container for Every Element
        me.rows.forEach(function(element) {
            var media = {
                mediaID: element.id,
                height: 300,
                width: 600,
                pos: 'bottom',
                show: true
            };
            me.visual.find(".vc-gallery-action").hover(function() { //mousein
                    $(this).toggleClass("color-font-secondary", false);
                    $(this).toggleClass("color-font-primary", true);
                },
                function() //mouseout
                {
                    $(this).toggleClass("color-font-primary", false);
                    $(this).toggleClass("color-font-secondary", true);
                });
            var sAppendIcons = "<div style='display:none;  width:425px'  class='fL " + mobileClass;
            if (element.is_standard_pic !== undefined) {
                if (element.is_standard_pic === "true") {
                    sAppendIcons += "signal-main-image ";
                }
            }
            sAppendIcons += "' id='file" + element.id + "'>" + "<div class='eI'>" + "<a onclick='downloadMediaDataUrl(\"" + element.path + "\")' >" + "<i class='fa fa-download color-font-secondary vc-gallery-action'></i></a>" + "<i class='fa fa-envelope email color-font-secondary vc-gallery-action' title='" + me.resources.sendEmail +
                "' data-id='" + element.id + "'></i> " + "<i data-id='" + element.id + "' class=' color-font-secondary fa fa-upload  edit vc-gallery-action' title='" + me.resources.editUpload + "'></i>";


            if (element.is_standard_pic !== undefined) {
                if (element.is_standard_pic === "true") {
                    sAppendIcons += "<div class='div-doc-type-info ' style='float:right; margin-right:5px;' data-id='" +element.id +"'><i class=' color-font-primary fa fa-star fa-lg gallery-image-standard gallery-image-standard-selected' style='float:right;' title='" +me.resources.standard +"'></i><div class='div-doc-type-name'>" + me.resources.standard + "</div></div>";
                } else {
                    sAppendIcons += "<div class='div-doc-type-info' style='float:right; margin-right:5px;' data-id='" + element.id + "'><i  class=' icon-inactive fa fa-star fa-lg gallery-image-standard' style='float:right;'  title='" +me.resources.setAsStandard +"'></i><div class='div-doc-type-name'>" + me.resources.documentation + "</div></div>";

                }
            }
            if (element.global === "true") {
                                   sAppendIcons += "<div style='float:right; margin-right:5px; cursorcursor:auto;'><i class='color-font-primary fa fa-globe fa-lg ' style='float:right; cursor:auto' title='" +me.resources.public +"'></i></div>";

            }
            sAppendIcons += "</div></div>";
            me.visual.find("#files")
                .append(sAppendIcons);
            window.VisualCoreService.getVisualContentByName("VISUAL_FILEVIEWER", element.id, window.getCurrentTimestamp(), 350, 425, JSON.stringify(media), "", 1, function (result) {
                me.visual.find("#file" + element.id).append(result).toggle();

                if (me.visual.find("#file" + element.id).find(".error").length > 0) {
                    me.visual.find("#file" + element.id + " .vc-gallery-action").addClass("disable").off("click");
                }

            });
        });

           me.visual.find(".gallery-image-standard").off("click").on("click",
              function () {
                  window._VCMQ.produce(me.visual, me.vcgid, 'GAL_SET_SIGNAL_STANDARD_IMAGE', { 'id': $(this).parent().attr('data-id'), 'unselect': $(this).hasClass('gallery-image-standard-selected'), 'category': me.mediaCategory, 'VCGID': me.vcgid });
              }
      );
        image = me.visual.find(".signal-main-image");
       image.remove();
        image.prependTo("#files");
       //me.visual.find(".gallery")

       
        me.visual.find(".email").off("click").on("click", function () {
            window._VCMQ.produce(me.visual, me.vcgid, 'GAL_SEND_EMAIL', { id: $(this).attr('data-id') });
        });
        if (me.editable) {
            me.visual.find(".edit").off("click").on("click", function () {
                window._VCMQ.produce(me.visual, me.vcgid, 'GAL_EDIT_FILE', { 'id': $(this).attr('data-id'), 'category': me.mediaCategory, 'VCGID': me.vcgid, editable: me.editable });
                return true;
            });
        } else {
            me.visual.find(".edit").addClass("disable");
        }

        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }
};
galleryList.prototype.onCellSelect = function (rowid, iCol, me) {
    ///<summary>
    ///function for the JQGRID to add behaviour to selected cells
    ///</summary>
    try {
        var cm = me.grid.jqGrid("getGridParam", "colModel");
        var colName = cm[iCol].name;

        switch (colName) {
            case 'downloadFile':
                break;
            case 'sendPerEmail':
                window._VCMQ.produce(me.visual, me.vcgid, 'GAL_SEND_EMAIL', { id: rowid});

                break;
            case 'preview':
                me.grid.jqGrid('setSelection', rowid, false);
                window._VCMQ.produce(me.visual, me.vcgid, 'GAL_OPEN_FILEVIEWER', { 'mediaID': rowid, 'VCGID': me.vcgid });
                break;
            default:
                if (me.editable) {
                    window._VCMQ.produce(me.visual, me.vcgid, 'GAL_EDIT_FILE', { 'id': rowid, 'VCGID': me.vcgid,  editable: me.editable});

                }
                break;
        }
    } catch (ex) {
        me.writeError("onCellSelect", ex);
    }
};

galleryList.prototype.doEvent = function (event) {
    ///<summary>
    ///general event function to add the behaviour
    ///so that it does not matter whether the files are shown in FileViewer or as List
    ///</summary>
    var me = this;
    try {
       switch (event.msg) {
           //view Event
           case "GAL_SET_SIGNAL_STANDARD_IMAGE":
               me.setGalleryStandardImage(event);
               break;
        case "GAL_OPEN_FILEVIEWER":
            var media = {
                mediaID: event.values.mediaID,height: 700,width: 1200,pos: 'right',show: true};
            window.VisualCoreService.getVisualContentByName("VISUAL_FILEVIEWER", "fileViewer", window.getCurrentTimestamp(),600,1300,JSON.stringify(media),'',2,function(result) {
                    $("<div>").attr("id", "fileViewer").html(result).dialog({
                        width: "auto",
                        height: "auto",
                        autoOpen: true,
                        modal: false,
                        resizable: true,
                        dialogClass: "no-close",
                        title: me.resources.fileViewer,
                        buttons: {
                            Ok: function() {
                                $(this).dialog("close").remove();
                            }
                        }
                    });
                });
            break;
        case "GAL_ADD_TO_LIST":
            var param = {
                mediaCategory: me.mediaCategory
            };
            var signalParam = {
                assID: -1,
                assTypeID: -1
            };
            window.VisualCoreService.addVisualBaseByName("divGal", "WIDGET_GALLERY", "lery", window.getCurrentTimestamp(), 400, 1800, JSON.stringify(param), JSON.stringify(signalParam), 2);

            break;

        case "GAL_EDIT_FILE":
           if (event.values.category === "PRIVATE") {
               window.VisualCoreService.getVisualContentByName("WIDGET_GALLERY_UPLOAD_PRIVATE",
                   "uploadDialog",
                   window.getCurrentTimestamp(),
                   600,
                   1300,
                   JSON.stringify({ mediaCategory: me.mediaCategory, editable: event.values.editable }),
                   JSON.stringify({ 'mediaId': event.values.id }),
                   2,
                   function(result) {
                       me.visual.html(result);
                   });
           } else if (me.isInstall === "true") {
               window.VisualCoreService.getVisualContentByName("WIDGET_GALLERY_UPLOAD_SIGNAL_INSTALL", "uploadDialog", window.getCurrentTimestamp(), 600, 1300, JSON.stringify({ mediaCategory: me.mediaCategory }), JSON.stringify({ 'mediaId': event.values.id, "signalid": me.bsaid }), 2, function (result) {
                   me.visual.html(result);
               });
           } else {
               window.VisualCoreService.getVisualContentByName("WIDGET_GALLERY_UPLOAD", "uploadDialog", window.getCurrentTimestamp(),600,1300,JSON.stringify({ mediaCategory: me.mediaCategory }),JSON.stringify({ 'mediaId': event.values.id }),2,function(result) {
                        me.visual.html(result);
                    });
            }
            break;
           case "GAL_SEND_EMAIL":
            
               window.VisualCoreService.getVisualContentByName("WIDGET_EMAIL_GALLERY", "uploadDialog", window.getCurrentTimestamp(), 750, 900, "", JSON.stringify({ "atid": event.values.id, "isInstall": me.isInstall, "divname": me.visual.id  }), 2,
                function (result) {
                    me.visual.html(result);
                });

            break;
        default:
            break;

        }
    } catch (ex) {
        me.writeError("doEvent", ex);

    }
};
galleryList.prototype.setGalleryStandardImage = function (event) {
    ///<summary>
    ///sets the standardimage for a signal by a) changing the icon and b) calling the webservice function 
    ///</summary>
    var me = this;
    var updateType;
    try {
        me.visual.find(".gallery-image-standard.gallery-image-standard-selected ~ .div-doc-type-name").html(me.resources.documentation);
        me.visual.find(".gallery-image-standard.gallery-image-standard-selected")
            .removeClass("gallery-image-standard-selected color-font-primary").addClass("icon-inactive")
            .attr("title", me.resources.setAsStandard);
        if (!event.values.unselect) {
            me.visual.find(".gallery-image-standard[data-id='" + event.values.id + "'] .div-doc-type-name").html(me.resources.standard);
            me.visual.find(".gallery-image-standard[data-id='" + event.values.id + "'] .fa-star")
                .removeClass("icon-inactive").addClass("gallery-image-standard-selected color-font-primary")
                .attr("title", me.resources.standard);
            updateType = 1;
        } else {
            updateType = 2;
        }
        window.VisualCoreService.updateData(me.vcvid, "1", window.getCurrentTimestamp(), 600, 1300, JSON.stringify({ "bsaid": me.bsaid, "mediaid": event.values.id, "updateType": updateType }), JSON.stringify({ "bsaid": me.bsaid, "mediaid": event.values.id, "updateType": updateType }), 2, 2, JSON.stringify({ "bsaid": me.bsaid, "mediaid": event.values.id, "updateType": updateType }),
                function (result) {
                    me.showInfo(result.retHTML, "", result.hasError);
                    if (!result.hasError) {
                        window._VCMQ.produce(me.visual, me.vcgid, 'GALLERY_CHANGED', {"id":me.bsaid});
                    }
                });     
    } catch (ex) {
        me.writeError("setGalleryStandardImage", ex);
    }
};
galleryList.prototype.initJqGrid = function () {
    ///<summary>
    ///initializes the JqGrid with it's settings
    ///</summary>
    var me = this;
    try {
        me.grid = me.visual.find('#fileTable').jqGrid({
            width: null,
            height: 350,
            shrinkToFit: false,
            forceFit: true,
            cmTemplate: { sortable: false, search: false, align: "left" },
            datatype: 'local',
            multiselect: false,
            rowNum: 10,
            rowList: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            loadonce: true,
            rownumbers: false,
            rownumWidth: 20,
            gridview: true,
            data: me.rows,
            colModel: me.colModel,
            pager: '#divGridFooter',
            viewrecords: true,
            ignoreCase: true,
            altRows: true,
            deepempty: true,
            onCellSelect: function(rowid, iCol) {
                me.onCellSelect(rowid, iCol, me);
            },

            gridComplete: function() {
                if (me.visual.find('#fileTable').jqGrid("getGridParam", "records") < 1) {
                    me.showEmptyMessage();
                }
            }
        });
        $(".ui-th-column").css({ "text-align": "left" });
    } catch (ex) {
        me.writeError("initJqGrid", ex);

    }
  
};
galleryList.prototype.showEmptyMessage = function () {
    ///<summary>
    ///shows a Message that no files do exists yet on the server
    ///</summary>
    var me = this;
    try {
        me.showInfo(me.resources.noEntriesExist, "", false);
    } catch (ex) {
        me.writeError("showEmptyMessage", ex);
    }
};
